// @ts-check
import { Component } from 'react';
import MaterialSnackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { getColor } from 'common/constants/_colors';
import { LBButton } from '@linearb/buzz';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles = () => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: getColor('torchRed')
  },
  info: {
    backgroundColor: getColor('chambray')
  },
  warning: {
    backgroundColor: amber[700]
  },
  notification: {
    backgroundColor: getColor('darkBlue'),
    maxWidth: '40.9rem',
    paddingBottom: '2rem'
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: '1rem'
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
});

function MySnackbarContentWrapper(props) {
  const {
    className,
    classes,
    message,
    onClose,
    variant,
    messageWrapper,
    actions,
    ...other
  } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby='client-snackbar'
      message={
        messageWrapper ? (
          messageWrapper(message)
        ) : (
          <span id='client-snackbar' className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        )
      }
      action={
        actions
          ? actions
          : [
              <LBButton
                key='close'
                aria-label='close'
                color='inherit'
                onClick={onClose}
                variant='ghost'
                size='icon'
              >
                <CloseIcon className={classes.icon} />
              </LBButton>
            ]
      }
      {...other}
    />
  );
}

const StyledSnackbarContentWrapper = withStyles(styles)(
  MySnackbarContentWrapper
);

export default class Snackbar extends Component {
  render() {
    const { toggleSnackBar, uiState } = this.props;
    const { isOpen } = uiState.snackBar;

    if (!isOpen) {
      return null;
    }

    const {
      onClick = () => toggleSnackBar({ isOpen: false }),
      onClose = () => toggleSnackBar({ isOpen: false }),
      autoHideDuration = 6000,
      message,
      variant = 'success',
      actions,
      position,
      messageWrapper,
      closeOnClick = 'onClick',
      anchorOrigin = {
        vertical: 'bottom',
        horizontal: position ? position : 'center'
      }
    } = _.get(uiState, 'snackBar.options', {});

    return (
      <MaterialSnackbar
        anchorOrigin={anchorOrigin}
        open={isOpen}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        ClickAwayListenerProps={{ mouseEvent: closeOnClick }}
      >
        <StyledSnackbarContentWrapper
          onClick={() => onClick}
          onClose={onClose}
          message={message}
          variant={variant}
          actions={actions}
          position={position}
          messageWrapper={messageWrapper}
        />
      </MaterialSnackbar>
    );
  }
}
